import React from "react";
import Modal from "../../styles/Modals";
import styled from "styled-components";
import Color from "../../assets/Colors";
import {ResetButton} from "../../styles/Button";
import useQuery from "../../hooks/useQuery";
// import {useHistory} from "react-router-dom";

export default function NewLetter() {
   let query = useQuery();
   const isOpen = query.get("newsLetter") === "true" ? true : false;
   // let history = useHistory();

   const regiterOnNews = (e) => {
      e.preventDefault();
   };

   if (!isOpen) return null;
   return (
      <Modal>
         <form onSubmit={regiterOnNews}>
            <TitleStyled>
               Se parte de la familia. <br />
               DOMECQ ACADEMY
            </TitleStyled>
            <TextStyled>Suscribete a nuestro newsletter y entérate de nuestros nuevos cursos y masterclass antes que nadie.</TextStyled>

            <InputStyled placeholder="Correo eléctronico" name="email" type="email" required />
            <ButtonSubmit>
               <ResetButton>ENVIAR</ResetButton>
            </ButtonSubmit>
         </form>
      </Modal>
   );
}

const TitleStyled = styled.p`
   color: ${Color.primary};
   font-weight: 200;
   font-size: 1.4em;
   margin: 2em 0 1em 0;

   @media screen and (max-width: 1600px) {
      font-size: 1.2em;
   }
`;

/* const SubtitleStyled = styled.p`
   color: ${Color.primary};
   font-weight: 500;
   font-size: 1.1em;
   margin-top: 2em;

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
`; */

const TextStyled = styled.p`
   font-size: 1.1em;
   color: grey;
   // margin-top: 0.5em;
   font-weight: 300;
   text-align: justify;

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
`;

const ButtonSubmit = styled.div`
   padding: 0 0.5em;
   width: 100%;
   box-sizing: border-box;

   & ${ResetButton} {
      width: 100%;
      padding: 1em;
      color: ${Color.primary};
      border: 1px solid ${Color.primary};
      &:hover {
         color: white;
         background-color: ${Color.primary};
      }
   }
`;

const InputStyled = styled.input`
   width: 100%;
   height: 100%;
   border: none;
   outline: none;
   border-bottom: 1px solid ${Color.textColor};
   color: ${(props) => props.color || Color.textColor};
   font-size: 1.4em;
   font-weight: 200;
   padding: 0.5em;
   margin-top: 2.5em;
   margin-bottom: 2em;

   @media screen and (max-width: 1600px) {
      font-size: 0.9em;
   }
`;
